/**
* @Author: Matthias Gohla <Matze>
* @Date:   2016-09-20T16:16:29+02:00
* @Email:  matze_lebt@gmx.de
* @Last modified by:   Matze
* @Last modified time: 2016-09-20T17:36:23+02:00
*/

import React, {Component} from 'react';
import PropTypes from 'prop-types';

/**
 * MHeadlineCheckout - …
**/
class MHeadlineCheckout extends Component {
  /**
     * TODO jsdoc
     *
     * @return {object}
     */
  render() {
    const {
      headline,
      labelInfo,
    } = this.props;
    return (
      <div className="m-headline m-headline-checkout">
        <h1 className="m-headline-checkout__headline">
          {headline}
        </h1>
        <div className="m-headline-checkout__pagenumbers">
          {labelInfo && labelInfo}
        </div>
      </div>
    );
  }
}

MHeadlineCheckout.propTypes = {
  headline: PropTypes.string.isRequired,
  labelInfo: PropTypes.string,
};
MHeadlineCheckout.defaultProps = {};
export default MHeadlineCheckout;

